// import { isProductionMode } from 'utils/utils';

const getBaseUrl = () => {
  if (process.env.REACT_APP_ENV === 'local') {
    return 'http://localhost:8888';
  }
  if (process.env.REACT_APP_ENV === 'development') {
    return 'https://dev-api.nanumprice.kr';
  }
  return 'https://api.nanumprice.kr';
};

const base = getBaseUrl();

const apis = {
  url: base,
  // 새로운 인증 API (일반 사용자용)
  auth: {
    signup: `${base}/api/auth/signup`,
    signin: `${base}/api/auth/signin`,
    checkEmail: `${base}/api/auth/check-email`,
    password: {
      reset: `${base}/api/auth/password/reset`,
      change: `${base}/api/auth/password/change`,
    },
    social: {
      authorize: (provider) => `${base}/api/auth/social/${provider}/authorize`,
      callback: (provider) => `${base}/api/auth/social/${provider}/callback`,
      signup: `${base}/api/auth/social/signup`,
      verify: (token) => `${base}/api/auth/social/verify/${token}`,
    },
  },
  // 기존 관리자 API (유지)
  account: {
    signup: `${base}/api/admin/account/signup`,
    signin: `${base}/api/admin/account/signin`,
    user: `${base}/api/admin/account/user`,
    password: {
      check: `${base}/api/admin/account/check/password`,
      update: `${base}/api/admin/account/update/password`,
      generate: `${base}/api/admin/account/generate/password`,
    },
    delete: `${base}/api/admin/account/delete`,
  },
  // 결제 API
  payment: {
    subscribe: `${base}/api/payment/subscribe`,
    subscription: `${base}/api/payment/subscription`,
    cancelSubscription: `${base}/api/payment/subscription/cancel`,
    changePlanPreview: `${base}/api/payment/subscription/change-plan/preview`,
    changePlan: `${base}/api/payment/subscription/change-plan`,
    history: `${base}/api/payment/history`,
  },
  data: {
    analysis: {
      estate: {
        addr: `${base}/api/data/analysis/estate/addr/list`,
        list: `${base}/api/data/analysis/estate/list`,
        date: `${base}/api/data/analysis/estate/date`,
      },
    },
  },
  alert: {
    setting: `${base}/api/alert/setting`,
  },
};

export { apis };
